// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.standinginstruction.SITemplate
import org.mifospay.core.model.standinginstruction.SIUpdatePayload
import org.mifospay.core.model.standinginstruction.StandingInstruction
import org.mifospay.core.model.standinginstruction.StandingInstructionPayload
import org.mifospay.core.network.model.entity.Page

@OptIn(InternalKtorfitApi::class)
public class _StandingInstructionServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : StandingInstructionService {
  override fun getStandingInstructionTemplate(
    fromOfficeId: Long,
    fromClientId: Long,
    fromAccountType: Long,
  ): Flow<SITemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "standinginstructions/template")
        fromOfficeId?.let{ parameter("fromOfficeId", "$it") }
        fromClientId?.let{ parameter("fromClientId", "$it") }
        fromAccountType?.let{ parameter("fromAccountType", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<SITemplate>>(),)!! 
  }

  override fun getAllStandingInstructions(clientId: Long): Flow<Page<StandingInstruction>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "standinginstructions")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<Page<StandingInstruction>>>(),)!! 
  }

  override fun getStandingInstruction(standingInstructionId: Long): Flow<StandingInstruction> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "standinginstructions/${"$standingInstructionId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<StandingInstruction>>(),)!! 
  }

  override suspend fun createStandingInstruction(payload: StandingInstructionPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "standinginstructions")
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun deleteStandingInstruction(instructionId: Long, command: String) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "standinginstructions/${"$instructionId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateStandingInstruction(
    instructionId: Long,
    payload: SIUpdatePayload,
    command: String,
  ) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "standinginstructions/${"$instructionId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _StandingInstructionServiceProvider : ClassProvider<StandingInstructionService> {
  override fun create(_ktorfit: Ktorfit): StandingInstructionService = _StandingInstructionServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createStandingInstructionService(): StandingInstructionService = _StandingInstructionServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
